import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer as MuiDrawer, makeStyles } from '@material-ui/core';
const useStyles = makeStyles(() => ({
    backdrop: {
        // This unique color is not part of themes
        backgroundColor: `#393939 !important`,
        opacity: '0.25 !important',
    },
}));
export const Drawer = (props) => {
    const classes = useStyles();
    const { children } = props, rest = __rest(props, ["children"]);
    return (_jsx(MuiDrawer, Object.assign({ BackdropProps: { className: classes.backdrop } }, rest, { children: children }), void 0));
};
//# sourceMappingURL=Drawer.js.map